import { SpringValue } from "react-spring";

// Defaults
export const defaultSpring = { x: 0, y: 0 };
export const defaultSpringValue = { x: new SpringValue(0), y: new SpringValue(0) };
